import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';

@Component({
  selector: 'app-mycourses',
  templateUrl: './mycourses.component.html',
  styleUrls: ['./mycourses.component.scss']
})
export class MycoursesComponent implements OnInit {
  public loadingPurchases:boolean = true;
  public purchasedCourses: Course[];

  constructor(private courseService:CourseService) { }

  ngOnInit() {
    this.courseService.getPurchasedCourses().subscribe(courses=>{
      this.purchasedCourses = courses;
      this.loadingPurchases = false;
    })
  }

}
